/**
 * Centralised route patterns.
 * If routes change (e.g. /tournaments/:slug), update only this file.
 */

// Tournament detail page (and any subpage that is NOT a match page or a
// per-participant statistics page). The negative lookahead excludes
// `/matches/...` and `/leaderboard/<digits>(/...)` so RouterNavigationSwiper
// can show the participant-scoped tab nav (Статистика / Прогнозы) on the
// latter, instead of the tournament tab nav.
export const tournamentDetailRoutePattern =
  /^\/tournaments\/(\d+)(\/(?!matches\/|leaderboard\/\d+).+)?$/;

// Match detail page (and its sibling pages like /predictions).
export const matchDetailRoutePattern = /^\/tournaments\/(\d+)\/matches\/(\d+)(\/.*)?$/;

// Per-participant statistics page (and its sibling pages like /predictions).
// `/tournaments/:tid/leaderboard/:uid` and
// `/tournaments/:tid/leaderboard/:uid/predictions`.
export const participantStatsRoutePattern =
  /^\/tournaments\/(\d+)\/leaderboard\/(\d+)(\/.*)?$/;

/**
 * Extract tournament id from any path that starts with `/tournaments/{number}`,
 * including match-detail subpaths. Returns null if no id is present.
 */
export function extractTournamentIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/tournaments\/(\d+)(?:\/|$)/);
  return match ? match[1] : null;
}

/**
 * Routes rendered through ContentLayout — they use the solid header. URL-only,
 * so the shell's first frame is right before the page's config applies.
 */
export function isContentLayoutRoute(pathname: string): boolean {
  return pathname.startsWith('/account') ||
    pathname.startsWith('/admin') ||
    pathname.startsWith('/matches') ||
    /^\/match\/\d+/.test(pathname) ||
    (pathname.startsWith('/tournaments') && pathname !== '/tournaments/create');
}
